import { IDynamicConfig, IDynamicFormConfig, DynamicConfig } from '@mt-ng2/dynamic-form';
import { CarrierDynamicControlsPartial } from '../model/partials/carrier-partial.form-controls';
import { ICarrier } from '../model/interfaces/carrier';

export class CarrierDynamicConfig<T extends ICarrier> extends DynamicConfig<T> implements IDynamicConfig<T> {
    constructor(private carrier: T, private configControls?: string[]) {
        super();
        const dynamicControls = new CarrierDynamicControlsPartial(this.carrier);
        // default form implementation can be overridden at the component level
        if (!configControls) {
            this.configControls = ['Name', 'InvoiceForPickupFees', 'CreditLimit', 'AccountNo'];
        }
        this.setControls(this.configControls, dynamicControls);
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getForUpdate(additionalConfigs?: any[]): IDynamicFormConfig {
        return {
            formObject: this.getFormObject(additionalConfigs),
            viewOnly: this.DynamicLabels,
        };
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getForCreate(additionalConfigs?: any[]): IDynamicFormConfig {
        return {
            formObject: this.getFormObject(additionalConfigs),
        };
    }
}
